import React from 'react';
import { UIConstants } from '../../shared/models/Constants';
import { render } from 'react-dom';
import { Label, ILabelStyles, mergeStyles, Spinner, SpinnerSize, IStyleFunctionOrObject, ILabelStyleProps, ShimmeredDetailsList, DetailsListLayoutMode, SelectionMode, TextField, DialogType, PrimaryButton, DefaultButton, Icon, IColumn, Checkbox, MessageBar, MessageBarType, IconButton, ProgressIndicator } from '@fluentui/react';
import AccessAPI from '../../store/AccessAPI';
import { ExternalAADRoles } from '../../shared/models/Role.model';
import ITenant from '../../shared/models/Tenant.model';
import { ExternalAADRolePermissions } from '../../shared/models/ExternalAADRolePermissions';
import { DialogModel } from '../../shared/models/Dialog.model';
import { ModalDialog } from '../ModalDialog';

const labelStyles: Partial<IStyleFunctionOrObject<ILabelStyleProps, ILabelStyles>> = {
    root: { marginTop: 7 }
};
export interface IpermissionsState {
  cosmosRoleDefinitions: ExternalAADRoles[];
  selectedBgName: string;
  rolesBasedOnBg: ExternalAADRoles[];
  selectedRoleName: string;
  selectedRoleId: string
  tenantName: string;
  tenantId: string;
  roleBasedpermissions: ExternalAADRolePermissions;
  isPermissionsLoaded: boolean
  searchText: string;
  permissionValues: string[];
  modalDialogContent: any;
  showDialog: boolean;
  showMessage: boolean;
  message: string;
  isCreateMode: boolean;
  submitInProgress: boolean;
  newlyAddedPermissions: string;
  removedPermissions: string[];
  isTerms1Agreed: boolean;
  isTerms2Agreed: boolean;
  enableCRUDOperations: boolean;
  isTenantAdmin: boolean;
}

export default class Permissions extends React.Component<IpermissionsState> {
  private _modalDialogContent: DialogModel = {
    type: DialogType.normal,
    title: UIConstants.MessageBoxTitle.SaveAccess,
    closeButtonAriaLabel: UIConstants.ButtonText.Close,
    subText: UIConstants.Messages.SaveConfirmation,
    okAction: null,
    cancelAction: null,
  };
  public state: IpermissionsState = {
    cosmosRoleDefinitions: [],
    selectedBgName: '',
    rolesBasedOnBg: [],
    selectedRoleName: '',
    selectedRoleId: '0',
    tenantName: '',
    tenantId: '',
    roleBasedpermissions: null,
    isPermissionsLoaded: false,
    searchText: '',
    permissionValues: [],
    modalDialogContent: this._modalDialogContent,
    showDialog: false,
    showMessage: false,
    message: '',
    isCreateMode: false,
    submitInProgress: false,
    newlyAddedPermissions: '',
    removedPermissions: [],
    isTerms1Agreed: false,
    isTerms2Agreed: false,
    enableCRUDOperations: false,
    isTenantAdmin: false,
  }

  public constructor(props) {
    super(props)
  }

  public componentDidMount() {
    let _tenantName = window.location.pathname.split('/').reverse()[0];
    let tenantConfig: ITenant[] = JSON.parse(sessionStorage.getItem('TenantConfig').replaceAll("\'", "\""));
    let tenantData = tenantConfig.filter(x => x.TenantName.toLowerCase() == _tenantName.toLowerCase())[0];
    const isTenantAdmin = sessionStorage.getItem('isTenantAdmin') === "true";
    this.setState({ tenantName: tenantData.TenantName, tenantId: tenantData.TenantId, isTenantAdmin }, () => {
      AccessAPI.getCosmosRoleDefinitions(this.state.tenantId).then(res => {
        let roleDefinitions: ExternalAADRoles[] = res;
        this.setState({ cosmosRoleDefinitions: roleDefinitions })
      });
    })
  }

  public render(): JSX.Element {
    const { cosmosRoleDefinitions, selectedBgName, rolesBasedOnBg, selectedRoleId, selectedRoleName, tenantId, searchText, permissionValues, showDialog, modalDialogContent, isCreateMode, submitInProgress, newlyAddedPermissions, isTerms1Agreed, isTerms2Agreed, showMessage, removedPermissions, isPermissionsLoaded, enableCRUDOperations, isTenantAdmin } = this.state
    return <React.Fragment>
      <div id={'div-msg-area'} style={{ height: 25 }}>
        {(showMessage && !showDialog) && this.renderMessage()}
        {(submitInProgress) && <ProgressIndicator label={UIConstants.Messages.SubmitInProgressTitle} description={UIConstants.Messages.SubmitInProgress} />}
      </div>
      <div id={'div-req-section'} style={{ padding: '1%', paddingTop: '2%' }} >
        <div key="grid-request" className={"ms-Grid"} dir="ltr">
          <div key='grid-row-role' className={"ms-Grid-row"}>
            <div className={"ms-Grid-col ms-sm6 ms-md8 ms-lg10"}>
              <Label style={{ paddingLeft: '5px', fontSize: 20 }} > <h1 role="heading" aria-level={1} className={"h1"} style={{ paddingLeft: 0, fontSize: 20, margin: 0 }}> {UIConstants.PageTitle.Permissions}</h1></Label>
            </div>
            <div className={"ms-Grid-col ms-sm12 ms-md8 ms-lg12"}>
              <div style={{ paddingLeft: '5px' }}>
                <Label required={true} styles={labelStyles}>{UIConstants.Group}</Label>
                <select id={'drpGrp'} value={selectedBgName}
                  title={UIConstants.Group} required={true}
                  onChange={this.onBusinessGroupChange}
                  style={{ height: 32, width: window.innerWidth < 400 ? 250 : 350 }}>
                  <option value="0">-- Select --</option>
                  {cosmosRoleDefinitions.length > 0 && this.getBusinessGroups().map(role => {
                    if (role.businessGroupId != null) {
                      { return <option value={role.businessGroupName}>{role.businessGroupName}</option> }
                    }
                  })}
                </select>
              </div>
            </div>
          </div>
          <div key='grid-row-role' className={"ms-Grid-row"}>
            <div className={"ms-Grid-col ms-sm12 ms-md8 ms-lg12"}>
              <div style={{ paddingLeft: '5px' }}>
                <Label required={true} styles={labelStyles}>{UIConstants.Role}</Label>
                <select id={'drpGrp'} value={selectedRoleId}
                  title={UIConstants.Group} required={true}
                  onChange={this.onRoleDrpDownChange}
                  style={{ height: 32, width: window.innerWidth < 400 ? 250 : 350 }}>
                  <option value="0">-- Select --</option>
                  {rolesBasedOnBg.length > 0 && rolesBasedOnBg.map(role => { return <option value={role.roleId}>{role.roleName}</option> })}
                </select>
              </div>
            </div>
          </div>
          {isPermissionsLoaded && selectedRoleId != '0' && enableCRUDOperations && <div key='grid-row-loadData' className={"ms-Grid-row"} style={{ paddingLeft: 5, paddingTop: 10 }}>
            <div className={"ms-Grid-col ms-sm12 ms-md8 ms-lg2"}>
              <span><TextField placeholder="Search for Permission" value={searchText} onChange={(ev, text) => this.setState({ searchText: text })} /></span>
            </div>
            <span><PrimaryButton title="Search" onClick={() => { this.validateSearch() }}><Icon iconName={'Search'} /></PrimaryButton></span>
            <span>&nbsp;&nbsp;</span>
            <DefaultButton title="Refresh" onClick={() => { this.getRolePermissions(tenantId, selectedRoleId) }} ><Icon iconName={'Refresh'} />&nbsp;Refresh</DefaultButton>
            <span>&nbsp;&nbsp;</span>
            {isTenantAdmin && <><DefaultButton title="Create" disabled={removedPermissions.length > 0} onClick={() => { this.onCreatePermissionClick() }} ><Icon iconName={'AddIn'} />&nbsp;Create New Permissions</DefaultButton>
            <span>&nbsp;&nbsp;</span>
            <DefaultButton title="Remove" disabled={removedPermissions.length <= 0} onClick={() => { this.onRemovePermissionClick() }} ><Icon iconName={'RemoveFromShoppingList'} />&nbsp;Remove Permissions</DefaultButton></>}
            <div className={"ms-Grid-col ms-sm12 ms-md12 ms-lg12"} style={{ paddingTop: 10 }}>
              {isTenantAdmin && <><Label>To create new permission(s) - <span style={{ fontSize: 14, fontWeight: 400 }}>please click on 'Create New Permissions'.</span></Label>
              <Label>To remove existing permission(s) - <span style={{ fontSize: 14, fontWeight: 400 }}>please select the corresponding permission checkbox for which you want to remove - then click on 'Remove Permissions'.</span></Label></>}
            </div>
          </div>
          }
          <div style={{ paddingLeft: '5px' }} key="work-area">
            {this.state.isPermissionsLoaded ? this.state.roleBasedpermissions && <ShimmeredDetailsList
              setKey="permission-items"
              columns={this.ColumnHeaders()}
              items={permissionValues}
              layoutMode={DetailsListLayoutMode.justified}
              selectionMode={SelectionMode.none}
              enableShimmer={false}
              ariaLabelForShimmer="Permissions are being fetched"
              ariaLabelForGrid="Role permissions"
              listProps={{ renderedWindowsAhead: 10, renderedWindowsBehind: 10 }}
            /> : selectedRoleName == '' ? null : <Spinner size={SpinnerSize.large} style={{ paddingLeft: 120, paddingTop: 30, alignItems: 'start' }} label="loading..." ariaLive="assertive" labelPosition="bottom" />}
          </div>
          {showDialog && <ModalDialog hidden={!showDialog}
            onDismiss={this.closeConfirmation}
            dialogContentProps={modalDialogContent}
            modalProps={{
              isBlocking: false,
              styles: { main: { maxWidth: 450 } },
            }}
            showMessage={this.state.showMessage}
            message={this.state.message}
            content={(modalDialogContent.okButtonText === UIConstants.ButtonText.Ok) &&
              <div> {isCreateMode ?
                <TextField
                  resizable={false} disabled={submitInProgress} placeholder="Enter new permissions separated by semi-colon(;)"
                  styles={{ root: { marginTop: 10 } }} label={UIConstants.ButtonText.Add} multiline rows={3}
                  value={newlyAddedPermissions} onChange={(ev, text) => { this.setState({ newlyAddedPermissions: text }) }} required
                /> : <div></div>}
                <div style={{ display: 'inline-flex', "alignItems": 'center' }}>
                  <span><Checkbox styles={{ root: { width: 20, marginTop: 10 } }} checked={isTerms1Agreed} onChange={(ev, checked) => { this.setState({ isTerms1Agreed: checked }) }} />
                  </span><span style={{ paddingLeft: 10 }}><Label style={{ fontWeight: "normal" }}><span>
                    By checking this box, I attest that I understand changing permissions will have a business impact.
                  </span></Label>
                  </span></div>
                <div style={{ display: 'inline-flex', "alignItems": 'center' }}>
                  <span><Checkbox styles={{ root: { width: 20, marginTop: 10 } }} checked={isTerms2Agreed} onChange={(ev, checked) => { this.setState({ isTerms2Agreed: checked }) }} />
                  </span><span style={{ paddingLeft: 10 }}><Label style={{ fontWeight: "normal" }}><span>
                    By checking this box, I attest that I have the business need and authority to make this change.
                  </span></Label>
                  </span>
                </div>
              </div>
            }
          >
          </ModalDialog>}
        </div>
      </div>
    </React.Fragment>
  }
  private validateSearch = () => {
    const { roleBasedpermissions, searchText } = this.state;
    let permissionsData = [];
    if (roleBasedpermissions.roleId) {
      let filteredPermissions = roleBasedpermissions.permissionValues.filter(x => x.toLowerCase().includes(searchText.toLowerCase()));
      permissionsData = this.getPermissions(filteredPermissions);
    }
    this.setState({ permissionValues: permissionsData });
  }
  private renderMessage = () => {
    let { message, showMessage } = this.state;
    if (showMessage) {
      setTimeout(() => { this.setState({ showMessage: false }) }, 10000); // hide message after 10 seconds
    }
    return <div role="alert" >
      <MessageBar key='SaveMsg' style={{ fontSize: '.875rem' }}
        actions={
          <div>
            <IconButton role="button" iconProps={{ iconName: 'Clear' }} title="Close" onClick={() => { this.setState({ showMessage: false }) }} />
          </div>
        }
        messageBarType={MessageBarType.info}
        isMultiline={false}
      >
        <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{message}</span>
      </MessageBar>
    </div>
  };
  private getBusinessGroups = () => {
    const { cosmosRoleDefinitions } = this.state;
    let globalRoles = null;
    let businessGroups: ExternalAADRoles[] = [{ roleId: '', roleName: '', businessGroupId: null, businessGroupName: '', tenantId: '', tenantName: '', policyType: '', allowSkipLevel: '' }]
    cosmosRoleDefinitions.forEach(x => {
      if (businessGroups.filter(y => y.businessGroupName == x.businessGroupName).length == 0) {
        businessGroups.push(x);
      }
    })
    if (businessGroups.findIndex(x => x.businessGroupName == 'Global_Roles') != -1) {
      globalRoles = businessGroups.splice(businessGroups.findIndex(x => x.businessGroupName == 'Global_Roles'), 1)[0];
    }
    businessGroups.sort((a, b) => {
      if (a.businessGroupName.toUpperCase() < b.businessGroupName.toUpperCase()) {
        return 1
      }
      else if (a.businessGroupName.toUpperCase() > b.businessGroupName.toUpperCase()) {
        return -1
      }
      else {
        return 0
      }
    })
    if (globalRoles) {
      businessGroups.push(globalRoles);
    }
    businessGroups.reverse();
    return businessGroups;
  }

  private onBusinessGroupChange = (event: any): void => {
    if (this.state) {
      const { cosmosRoleDefinitions } = this.state;

      let selectedBusinessGroupName = event.target.value;
      let rolesBesedOnSelectedBg = cosmosRoleDefinitions.filter(x => x.businessGroupName == selectedBusinessGroupName);
      rolesBesedOnSelectedBg.sort((a, b) => {
        if (a.roleName.toUpperCase() > b.roleName.toUpperCase()) {
          return 1
        }
        else if (a.roleName.toUpperCase() < b.roleName.toUpperCase()) {
          return -1
        }
        else {
          return 0
        }
      })
      this.setState({ rolesBasedOnBg: rolesBesedOnSelectedBg, selectedBgName: selectedBusinessGroupName, isPermissionsLoaded: false, selectedRoleName: '' });
    }
  }

  private onRoleDrpDownChange = (event: any): void => {
    const { tenantId, cosmosRoleDefinitions, selectedBgName } = this.state;
    if (event.target.value == '0') {
      this.setState({ isPermissionsLoaded: false, selectedRoleName: '', selectedRoleId: '0' })
    }
    else {
      this.setState({ isPermissionsLoaded: false, selectedRoleName: '0' })
      let roleId = event.target.value;
      let roleName = cosmosRoleDefinitions.filter(x => x.roleId == roleId)[0].roleName;
      if (selectedBgName == UIConstants.Global_Roles || roleName == UIConstants.BusinessOwner) {
        let permissionsforSelectedRole: ExternalAADRolePermissions = { roleId: roleId, roleName: roleName, permissionValues: [] };
        this.setState({ enableCRUDOperations: false, permissionValues: [], isPermissionsLoaded: true, roleBasedpermissions: permissionsforSelectedRole });
      }
      else {
        this.getRolePermissions(tenantId, roleId);
        this.setState({ enableCRUDOperations: true });
      }
      this.setState({ selectedRoleId: roleId, selectedRoleName: roleName });
    }
  }
  private getRolePermissions = (tenantId: string, roleId: string) => {
    this.setState({ isPermissionsLoaded: false, searchText: '', isTerms1Agreed: false, isTerms2Agreed: false, removedPermissions: [], newlyAddedPermissions: '', isCreateMode: false });
    let permissionsforSelectedRole: ExternalAADRolePermissions = { roleId: null, roleName: '', permissionValues: [] };
    AccessAPI.GetRolePermissions(tenantId, roleId).then(permissions => {
      let permissionsData = [];
      if (permissions) {
        permissionsforSelectedRole = permissions;
        permissionsData = this.getPermissions(permissionsforSelectedRole.permissionValues);
      }
      this.setState({ isPermissionsLoaded: true, roleBasedpermissions: permissionsforSelectedRole, permissionValues: permissionsData })
    });
  }
  private ColumnHeaders = () => {
    let columnDef = [
      ...(this.state.isTenantAdmin ? [{ key: 'remove', name: 'Remove', fieldName: 'remove', minWidth: 80, maxWidth: 80, isResizable: false, onRender: this._onRenderItemColumn }] : []),
      { key: 'permissions', name: 'Permissions', fieldName: 'permissions', minWidth: 500, maxWidth: 500, isResizable: true }
    ];
    return columnDef;
  }
  private _onRenderItemColumn = (item: any, index: number, column: IColumn): JSX.Element | React.ReactText => {
    const itemClass = mergeStyles({
      selectors: {
        '&:hover': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    });
    if (column.key === 'remove') {
      return (
        <div className={itemClass}>
          <Checkbox
            onChange={(e, checked) => {
              let removedPermissions = this.state.removedPermissions;
              if (checked) {
                removedPermissions.push(item.permissions);
              } else {
                removedPermissions = removedPermissions.filter(p => p !== item.permissions);
              }
              this.setState({ removedPermissions });
            }}
          />
        </div>
      );
    }
  }
  private getPermissions = (permissions: string[]) => {
    let permissionsData = [];
    permissions.forEach(item => {
      permissionsData.push({ permissions: item })
    })
    permissionsData.sort((a, b) => {
      if (a.permissions.toUpperCase() < b.permissions.toUpperCase()) {
        return -1
      }
      else if (a.permissions.toUpperCase() > b.permissions.toUpperCase()) {
        return 1
      }
      else {
        return 0
      }
    })
    return permissionsData;
  }
  private onCreatePermissionClick() {
    let msgText = "Please add new permissions in the below text box in semicolon separated format."
    this._modalDialogContent = {
      subText: msgText,
      title: UIConstants.MessageBoxTitle.CreatePermissions,
      okButtonText: UIConstants.ButtonText.Ok,
      type: DialogType.normal,
      okAction: () => this.createPermissions(),
      cancelAction: this.closeConfirmation,
      closeMessageAction: this.closeConfirmation,
      closeButtonAriaLabel: UIConstants.ButtonText.Cancel,
    }
    this.setState({ showDialog: true, modalDialogContent: this._modalDialogContent, isCreateMode: true, showMessage: false });
  }
  private onRemovePermissionClick() {
    let msgText = "Are you sure you want to remove the selected permissions?"
    this._modalDialogContent = {
      subText: msgText,
      title: UIConstants.MessageBoxTitle.RemovePermissions,
      okButtonText: UIConstants.ButtonText.Ok,
      type: DialogType.normal,
      okAction: () => this.removePermissions(),
      cancelAction: this.closeConfirmation,
      closeMessageAction: this.closeConfirmation,
      closeButtonAriaLabel: UIConstants.ButtonText.Cancel,
    }
    this.setState({ showDialog: true, modalDialogContent: this._modalDialogContent, isCreateMode: false, showMessage: false });
  }

  private closeConfirmation = (): void => {
    this.setState({ showDialog: false, showMessage: false, isTerms1Agreed: false, isTerms2Agreed: false });
  };
  private createPermissions = (): void => {
    const { tenantId, selectedRoleId, newlyAddedPermissions } = this.state;
    if (this.state.isTerms1Agreed && this.state.isTerms2Agreed) {
      let permissionsToAdd = newlyAddedPermissions.split(';').map(p => p.trim()).filter(p => p.length > 0);
      if (permissionsToAdd != null && permissionsToAdd.length > 0) {
        this.setState({ submitInProgress: true });
        AccessAPI.UpdateRolePermissions(tenantId, selectedRoleId, true, permissionsToAdd).then(res => {
          if (res == "Success") {
            this.setState({ showMessage: true, message: "Permissions created successfully.", newlyAddedPermissions: '', showDialog: false, submitInProgress:false });
            this.getRolePermissions(tenantId, selectedRoleId);
          }
          else {
            this.setState({ showMessage: true, message: res, submitInProgress: false });
          }
        });
      }
      else {
        this.setState({ showMessage: true, message: "Please enter at least one valid permission to create." });
      }
    }
    else {
      this.setState({ showMessage: true, message: "Please agree to the attestations before proceeding." });
    }
  }
  private removePermissions = (): void => {
    const { tenantId, selectedRoleId, removedPermissions } = this.state;
    if (this.state.isTerms1Agreed && this.state.isTerms2Agreed) {
      this.setState({ submitInProgress: true });
      AccessAPI.UpdateRolePermissions(tenantId, selectedRoleId, false, removedPermissions).then(res => {
        if (res == "Success") {
          this.setState({ showMessage: true, message: "Permissions removed successfully.", removedPermissions: [], showDialog: false, submitInProgress: false });
          this.getRolePermissions(tenantId, selectedRoleId);
        }
        else {
          this.setState({ showMessage: true, message: res, submitInProgress: false });
        }
      });
    }
    else {
      this.setState({ showMessage: true, message: "Please agree to the attestations before proceeding." });
    }
  }
}


